var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { observable, computed, action } from 'mobx';
import { api } from 'helpers/Api';
import { CollaboratorTicket, PacketTicket, Ticket } from '../Reports/Model';
import Voucher from '../Vouchers/Model';
export var EResult;
(function (EResult) {
    EResult["Operarios"] = "operarios";
    EResult["LineasOperacion"] = "lineasOperacion";
    EResult["Servicios"] = "servicios";
    EResult["CollaboratorServices"] = "collaboratorServices";
    EResult["Packets"] = "packets";
    EResult["ServicesInPackets"] = "servicesInPackets";
    EResult["Afiliados"] = "afiliados";
    EResult["DiscountReasons"] = "discountReasons";
    EResult["Categories"] = "categories";
})(EResult || (EResult = {}));
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.loadedSales = false;
        this.loadedCalendar = false;
        this.resultSalesReport = [];
        this._ticketsCalendarReport = [];
        this._collaboratorTicketsCalendarReport = [];
        this._collaboratorOperatorTicketsCalendarReport = [];
        this._vouchersCalendarReport = [];
        this._packetTicketsCalendarReport = [];
        this.calendarReport = function (range, typeList, start, end) {
            _this.loadedCalendar = false;
            return api.post("/tickets/calendar/".concat(range), { typeList: typeList, start: start, end: end }).then(function (reports) {
                return _this.setResultCalendarReport(reports);
            });
        };
        this.setResultCalendarReport = function (results) {
            var _a, _b, _c, _d, _e;
            _this.loadedCalendar = true;
            // filtro los que no pertenezcan a paquetes y los que no rectifican
            _this._ticketsCalendarReport = ((_a = results.tickets) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return !item.packetTicket_id && !item.refund_id; }).map(function (result) { return new Ticket(result); })) || [];
            _this._vouchersCalendarReport = ((_b = results.vouchers) === null || _b === void 0 ? void 0 : _b.map(function (result) { return new Voucher(result); })) || [];
            _this._packetTicketsCalendarReport = ((_c = results.packetTickets) === null || _c === void 0 ? void 0 : _c.filter(function (item) { return !item.refund_id; }).map(function (result) { return new PacketTicket(result); })) || [];
            _this._collaboratorTicketsCalendarReport = ((_d = results.collaboratorTickets) === null || _d === void 0 ? void 0 : _d.filter(function (item) { return !item.refund_id; }).map(function (result) { return new CollaboratorTicket(result); })) || [];
            _this._collaboratorOperatorTicketsCalendarReport = ((_e = results.collaboratorOperatorTickets) === null || _e === void 0 ? void 0 : _e.filter(function (item) { return !item.refund_id; }).map(function (result) { return new CollaboratorTicket(result); })) || [];
            return _this.getCalendarReport;
        };
    }
    Object.defineProperty(default_1.prototype, "result", {
        get: function () {
            return this.resultSalesReport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "resultCalendar", {
        get: function () {
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], this._ticketsCalendarReport, true), this._packetTicketsCalendarReport, true), this._collaboratorTicketsCalendarReport, true), this._collaboratorOperatorTicketsCalendarReport, true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "resultDashboard", {
        get: function () {
            return __spreadArray(__spreadArray(__spreadArray([], this._ticketsCalendarReport, true), this._packetTicketsCalendarReport, true), this._collaboratorTicketsCalendarReport, true);
            // los que han vendido los colaboradores no, los que he vendido como colaborador son los que son válidos para el dashboard
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "getTicketsCalendarReport", {
        get: function () {
            return this._ticketsCalendarReport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "getCollaboartorTicketsCalendarReport", {
        get: function () {
            return this._collaboratorTicketsCalendarReport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "getCollaboartorOperatorTicketsCalendarReport", {
        get: function () {
            return this._collaboratorOperatorTicketsCalendarReport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "getVouchersCalendarReport", {
        get: function () {
            return this._vouchersCalendarReport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "getPacketTicketsCalendarReport", {
        get: function () {
            return this._packetTicketsCalendarReport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "getCalendarReport", {
        get: function () {
            return {
                tickets: this._ticketsCalendarReport,
                vouchers: this._vouchersCalendarReport,
                packetTickets: this._packetTicketsCalendarReport,
                collaboratorTickets: this._collaboratorTicketsCalendarReport,
                collaboratorOperatorTickets: this._collaboratorOperatorTicketsCalendarReport
            };
        },
        enumerable: false,
        configurable: true
    });
    default_1.prototype.salesReport = function (range, from, to) {
        // console.log('DashboardTicketStore - salesReport')
        var _this = this;
        this.loadedSales = false;
        if (range) {
            return api.post("/tickets/totalsale/".concat(range), { from: from, to: to }).then(function (totalSales) {
                // console.log('DashboardTicketStore - totalSales: ', totalSales)
                return _this.setResult(totalSales);
            });
        }
        return api.get("/tickets/totalsale").then(function (totalSales) {
            // console.log('DashboardTicketStore - totalSales: ', totalSales)
            return _this.setResult(totalSales);
        });
    };
    default_1.prototype.customerReport = function (range) {
        var _this = this;
        this.loadedCalendar = false;
        return api.get("/tickets/salescustomers/".concat(range)).then(function (totals) {
            _this.loadedCalendar = true;
            return _this.setResultCalendarReport(totals);
        });
    };
    default_1.prototype.setResult = function (result) {
        this.loadedSales = true;
        this.resultSalesReport = result;
        return this.resultSalesReport;
    };
    __decorate([
        observable
    ], default_1.prototype, "loadedSales", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loadedCalendar", void 0);
    __decorate([
        observable
    ], default_1.prototype, "resultSalesReport", void 0);
    __decorate([
        observable
    ], default_1.prototype, "_ticketsCalendarReport", void 0);
    __decorate([
        observable
    ], default_1.prototype, "_collaboratorTicketsCalendarReport", void 0);
    __decorate([
        observable
    ], default_1.prototype, "_collaboratorOperatorTicketsCalendarReport", void 0);
    __decorate([
        observable
    ], default_1.prototype, "_vouchersCalendarReport", void 0);
    __decorate([
        observable
    ], default_1.prototype, "_packetTicketsCalendarReport", void 0);
    __decorate([
        computed
    ], default_1.prototype, "result", null);
    __decorate([
        computed
    ], default_1.prototype, "resultCalendar", null);
    __decorate([
        computed
    ], default_1.prototype, "resultDashboard", null);
    __decorate([
        computed
    ], default_1.prototype, "getTicketsCalendarReport", null);
    __decorate([
        computed
    ], default_1.prototype, "getCollaboartorTicketsCalendarReport", null);
    __decorate([
        computed
    ], default_1.prototype, "getCollaboartorOperatorTicketsCalendarReport", null);
    __decorate([
        computed
    ], default_1.prototype, "getVouchersCalendarReport", null);
    __decorate([
        computed
    ], default_1.prototype, "getPacketTicketsCalendarReport", null);
    __decorate([
        computed
    ], default_1.prototype, "getCalendarReport", null);
    __decorate([
        action
    ], default_1.prototype, "calendarReport", void 0);
    __decorate([
        action
    ], default_1.prototype, "salesReport", null);
    __decorate([
        action
    ], default_1.prototype, "customerReport", null);
    __decorate([
        action
    ], default_1.prototype, "setResult", null);
    __decorate([
        action
    ], default_1.prototype, "setResultCalendarReport", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DashboardTicket/Store.ts
// module id = 327
// module chunks = 0